/*
 * Copyright (c) 2024. Nedaware SL
 */

import {BasicEntity, BasicProperty} from "../../../basic-entity-back/annotations";
import {PropertyType} from "../../../basic-entity-back/property-type/property-type";
import {NestedBehavior} from "../../../basic-entity-back/property-type/nested-model-type";
import {BaseEntity} from "../../base-entity.model";
import {Uri} from "../../../api/uri";
import {FormaPago} from "./forma-pago.model";
import {ManagerCachingStrategy, PropertyMap} from "../../../basic-entity-back/basic-entity-interface/mapping-external";
import {CuentaBancariaCliente} from "../cuentas-bancarias/cuenta-bancaria-cliente.model";
import {Cliente} from "../../personas/cliente.model";

@BasicEntity({
    name: 'Forma de pago del cliente',
    endpoint: 'forma_pago_clientes',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'lectura',
    type: 'FormaPagoCliente',
    managerCaching: ManagerCachingStrategy.Lazy
})
export class FormaPagoCliente extends BaseEntity {
    @BasicProperty({
        isId: true,
        name: 'ID',
        type: PropertyType.Integer()
    })
    private _id: number;

    @BasicProperty({
        name: 'Descripción',
        type: PropertyType.String(),
        nullable: true
    })
    private _descripcion: string;

    @BasicProperty({
        name: 'Forma de pago',
        type: PropertyType.NestedModel(FormaPago, null, NestedBehavior.SendIriOnly),
    })
    private _formaPago;

    public static readonly MAP_CLIENTE: PropertyMap = {
        name: 'Cliente',
        type: PropertyType.FutureUri('cliente.model.ts')
    }
    @BasicProperty(FormaPagoCliente.MAP_CLIENTE)
    private _cliente;

    @BasicProperty({
        name: 'Cuenta bancaria',
        type: PropertyType.NestedModel(CuentaBancariaCliente, null, NestedBehavior.SendIriOnly),
        nullable: true
    })
    private _cuentaBancariaCliente;

    @BasicProperty({
        name: 'Por defecto',
        type: PropertyType.Boolean(),
    })
    private _porDefecto = true;

    @BasicProperty({
        name: 'Vigente',
        type: PropertyType.Boolean(),
    })
    private _vigente = true;

    get lectura() {
        let desc = '';
        if (this._descripcion) {
            desc = this._descripcion + (this._cuentaBancariaCliente ? ' (' + this._cuentaBancariaCliente.lectura + ')' : '');
        } else {
            desc = this._formaPago.nombre;
        }
        if (this.vigente) {
            desc += this.porDefecto ? ' (Por defecto)' : '';
        } else {
            desc += ' (Histórico)';
        }
        return desc;
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get descripcion(): string {
        return this._descripcion;
    }

    set descripcion(value: string) {
        this._descripcion = value;
    }

    get formaPago() {
        return this._formaPago;
    }

    set formaPago(value) {
        this._formaPago = value;
    }

    get cliente() {
        return this._cliente;
    }

    set cliente(value) {
        this._cliente = value;
    }

    get cuentaBancariaCliente() {
        return this._cuentaBancariaCliente;
    }

    set cuentaBancariaCliente(value) {
        this._cuentaBancariaCliente = value;
    }

    get porDefecto(): boolean {
        return this._porDefecto;
    }

    set porDefecto(value: boolean) {
        this._porDefecto = value;
    }

    get vigente(): boolean {
        return this._vigente;
    }

    set vigente(value: boolean) {
        this._vigente = value;
    }
}

